const BASE = "/api/aichat";

// T6: 增量拉取 id > afterId 的消息(用于断线重连后同步)
export async function getMessagesAfter(sessionId, afterId, { signal } = {}) {
  const url = `${BASE}/sessions/${sessionId}/messages?after=${encodeURIComponent(afterId)}`;
  const res = await fetch(url, { credentials: "same-origin", signal });
  if (!res.ok) {
    let errData = {};
    try { errData = await res.json(); } catch {}
    const err = new Error(errData.message || `HTTP ${res.status}`);
    err.code = errData.code;
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function resetMessageForRetry(sessionId, userMessageId) {
  const res = await fetch(`${BASE}/sessions/${sessionId}/messages/${userMessageId}/reset-for-retry`, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: "{}",
  });
  if (!res.ok) {
    let errData = {};
    try { errData = await res.json(); } catch {}
    throw new Error(errData.message || `HTTP ${res.status}`);
  }
  return res.json();
}
